/* eslint-disable */
import React, { Component } from 'react';
import moment from 'moment';
import Loader from '../../common/LoadingSpinner';
import * as api from '../../../epics/api';

const getBookingStatusString = job => {
    const effectiveDatetimeStarted = job.booking
        ? job.booking.datetime_started
        : null;
    const effectiveDatetimeFinished = job.booking
        ? job.booking.datetime_finished
        : null;
    let currentStatus;
    const todayDate = moment().format('YYYY-MM-DD');

    if (job.booking.status == 'OK' && job.date == todayDate) {
        if (!effectiveDatetimeStarted && !effectiveDatetimeFinished) {
            currentStatus = 'Planned';
        } else if (effectiveDatetimeStarted && !effectiveDatetimeFinished) {
            currentStatus = 'Ongoing';
        } else if (effectiveDatetimeStarted && effectiveDatetimeFinished) {
            currentStatus = 'Completed';
        }
    } else if (job.booking.status == 'OK') {
        if (effectiveDatetimeStarted && effectiveDatetimeFinished) {
            currentStatus = 'Completed';
        } else {
            currentStatus = 'Confirmed';
        }
    } else {
        currentStatus = job.booking.status;
    }
    return currentStatus;
};

class BookingStatusSelectPicker extends Component {
    constructor(props) {
        super(props);
        this.state = {
            updatingBookingStatus: false,
            currentBookingStatus: this.getCurrentBookingStatus(props),
        };
        this.handleBookingStatusChange =
            this.handleBookingStatusChange.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            currentBookingStatus: this.getCurrentBookingStatus(nextProps),
        });
    }

    getCurrentBookingStatus(props) {
        return getBookingStatusString(props.job);
    }

    handleBookingStatusChange(event) {
        const self = this;
        self.setState({ updatingBookingStatus: true });

        const selectedStatus = event.target.value;
        const data = { status: selectedStatus };
        const response = api.executeHttpRequest(
            `jobs/${this.props.relevantJobId}/bookings/${self.props.job.booking.id}/`,
            'patch',
            data,
        );
        response.then(res => {
            self.setState({
                currentBookingStatus: selectedStatus,
                updatingBookingStatus: false,
            });
            self.props.notification.success(
                'Success',
                `${self.props.job.booking.reference_number} status has successfully updated.`,
            );
        });
        response.catch(err => {
            self.setState({
                updatingBookingStatus: false,
            });
            self.props.notification.error(
                'Error',
                `${self.props.job.booking.reference_number} status could not be updated`,
            );
        });
    }

    render() {
        if (this.state.updatingBookingStatus) {
            return <Loader color="gray" size="10px" className="x-small" />;
        }
        return (
            <select
                disabled={this.props.disabled}
                onChange={this.handleBookingStatusChange}
                defaultValue={this.state.currentBookingStatus}
            >
                <option value="OK">Confirmed</option>
                <option value="UN">Unsatisfied</option>
                <option value="CA">Client cancelled</option>
                <option value="FC">Worker cancelled</option>
                <option value="NS">No show</option>
                <option value="BU">Backup</option>
                <option value="BC">Backup cancelled</option>
                <option disabled={true} hidden={true}>
                    Planned
                </option>
                <option disabled={true} hidden={true}>
                    Ongoing
                </option>
                <option disabled={true} hidden={true}>
                    Completed
                </option>
            </select>
        );
    }
}

export default BookingStatusSelectPicker;
